import React from 'react';

import { Pill } from 'ui-components/components/pill';
import messages from './messages';

import style from './style.module.less';
import { FormattedMessage } from 'react-intl';

export const ExchangeIndicator = () => {
  return <Pill className={style['exchange-indicator']} label={<FormattedMessage {...messages.exchange} />} />;
};
